module.exports = __webpack_public_path__ + "img/eqLedgerlnfo.cb146f31.svg";